// https://stackoverflow.com/a/21009108
const amazonRegex = /Kindle|Silk|KFAPW|KFARWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFSAW|KFSOWI|KFTBW|KFTHW|KFTT|WFFOWI/i;

class Device {
    static TYPE = {
        ANDROID: 'ANDROID',
        iOS: 'iOS',
        WINDOWS: 'WINDOWS',
        OPERA: 'OPERA',
        AMAZON: 'AMAZON',
        UNKNOWN: 'UNKNOWN',
    };

    /**
     * Looks for the useragent and returns the corresponding device
     */
    static findDeviceType() {
        let deviceType;
        if (navigator.userAgent.match(amazonRegex)) {
            deviceType = Device.TYPE.AMAZON;
        } else if (navigator.userAgent.match(/Android/i)) {
            deviceType = Device.TYPE.ANDROID;
        } else if (navigator.userAgent.match(/(iPad|iPhone)/g)) {
            deviceType = Device.TYPE.iOS;
        } else if (navigator.userAgent.match(/Opera Mini/i)) {
            deviceType = Device.TYPE.OPERA;
        } else if (navigator.userAgent.match(/Windows Phone/i)) {
            deviceType = Device.TYPE.WINDOWS;
        } else {
            deviceType = Device.TYPE.UNKNOWN;
        }
        return deviceType;
    }
}

export default Device;
